import React, { SVGProps } from 'react';

const SvgPencilLineSoildIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 18 18" {...props}>
    <path
      fill="#6B6B6B"
      d="M15.228 2.022a1.781 1.781 0 0 0-2.519 0l-.785.785 2.52 2.519.784-.785a1.781 1.781 0 0 0 0-2.52ZM13.723 6.046l-2.519-2.52-8.245 8.246a3.562 3.562 0 0 0-.895 1.502l-.543 1.822a.509.509 0 0 0 .633.633l1.822-.543a3.562 3.562 0 0 0 1.502-.895l8.245-8.245Z"
    />
    <path stroke="#6B6B6B" strokeLinecap="round" strokeWidth={1.5} d="M7.875 15H15" />
  </svg>
);
SvgPencilLineSoildIcon.defaultProps = {
  width: '24',
  height: '24',
  color: 'currentColor',
};
export default SvgPencilLineSoildIcon;
